module.exports = __webpack_public_path__ + "static/media/high-twoedge-2.5cfbb359.png";